import './checkboxField.css'
import CheckedIcon from 'components/UI/icons/CheckedIcon'

const CheckboxField = ({
  id,
  name,
  checked,
  semiChecked,
  contantSize, // wielkosc na mobile taka sama jak na desktop
  disabled,
  onClick,
  children,
}) => {
  const handleClick = () => {
    if (!disabled) onClick(name, !checked)
  }
  let className = 'checkbox__field'
  let checkboxClassName = 'checkbox__checkbox'
  if (disabled) checkboxClassName += ' chbx_disabled'
  if (checked) {
    checkboxClassName += ' chbx_checked'
    if (semiChecked) checkboxClassName += ' chbx_semichecked'
  }
  if (contantSize) {
    checkboxClassName += ' chbx_constant_size'
    className += ' chbxfld_constant_size'
  }

  return (
    <div id={id} className={className} onClick={handleClick}>
      <input type="checkbox" disabled={disabled} />
      <div className={checkboxClassName}>{checked && <CheckedIcon />}</div>
      {children}
    </div>
  )
}
export default CheckboxField
